<template>
    <div class="section min-w-0 mb-10 bg-white rounded-lg shadow-xs dark:bg-gray-800 overflow-hidden">
        <div class="p-4 flex flex-row items-center rounded-t-lg bg-gray-200 dark:text-gray-200 dark:bg-gray-600 text-gray-600 dark:text-gray-300">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3 cursor-move section-handle" viewBox="0 0 512 512" fill="currentColor">
                <path d="M512 256c0 6.797-2.891 13.28-7.938 17.84l-80 72C419.6 349.9 413.8 352 408 352c-3.312 0-6.625-.6875-9.766-2.078C389.6 346.1 384 337.5 384 328V288h-96v96l40-.0013c9.484 0 18.06 5.578 21.92 14.23s2.25 18.78-4.078 25.83l-72 80C269.3 509.1 262.8 512 255.1 512s-13.28-2.89-17.84-7.937l-71.1-80c-6.328-7.047-7.938-17.17-4.078-25.83s12.44-14.23 21.92-14.23l39.1 .0013V288H128v40c0 9.484-5.578 18.06-14.23 21.92C110.6 351.3 107.3 352 104 352c-5.812 0-11.56-2.109-16.06-6.156l-80-72C2.891 269.3 0 262.8 0 256s2.891-13.28 7.938-17.84l80-72C95 159.8 105.1 158.3 113.8 162.1C122.4 165.9 128 174.5 128 184V224h95.1V128l-39.1-.0013c-9.484 0-18.06-5.578-21.92-14.23S159.8 94.99 166.2 87.94l71.1-80c9.125-10.09 26.56-10.09 35.69 0l72 80c6.328 7.047 7.938 17.17 4.078 25.83s-12.44 14.23-21.92 14.23l-40 .0013V224H384V184c0-9.484 5.578-18.06 14.23-21.92c8.656-3.812 18.77-2.266 25.83 4.078l80 72C509.1 242.7 512 249.2 512 256z"/>
            </svg>

            <label class="block text-sm w-2/5">
                <jet-input type="text"
                           class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-red-400 focus:outline-none focus:shadow-outline-red dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
                           placeholder="Section Title"
                           v-model="sectionModel.name"
                           @change.prevent="saveQuote"
                />
            </label>

            <button @click.prevent="cloneSelf"
                    class="flex items-center justify-between p-2 ml-auto font-medium leading-5 text-white transition-colors duration-150 bg-gray-600 border border-transparent rounded-lg active:bg-gray-600 hover:bg-gray-700 dark:bg-gray-500 dark:hover:bg-gray-400 focus:outline-none focus:shadow-outline-gray"
                    title="Clone Section"
            >
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M9 2a2 2 0 00-2 2v8a2 2 0 002 2h6a2 2 0 002-2V6.414A2 2 0 0016.414 5L14 2.586A2 2 0 0012.586 2H9z" />
                    <path d="M3 8a2 2 0 012-2v10h8a2 2 0 01-2 2H5a2 2 0 01-2-2V8z" />
                </svg>
            </button>
            <button @click.prevent="removeSelf"
                    class="flex items-center justify-between p-2 ml-1 font-medium leading-5 text-white transition-colors duration-150 bg-gray-600 border border-transparent rounded-lg active:bg-gray-600 hover:bg-gray-700 dark:bg-gray-500 dark:hover:bg-gray-400 focus:outline-none focus:shadow-outline-gray"
                    title="Delete Section"
            >
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none"
                     viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                </svg>
            </button>
            <button @click.prevent="section.shown = !section.shown"
                    class="flex items-center justify-between p-2 ml-1 font-medium leading-5 text-white transition-colors duration-150 bg-gray-600 border border-transparent rounded-lg active:bg-gray-600 hover:bg-gray-700 dark:bg-gray-500 dark:hover:bg-gray-400 focus:outline-none focus:shadow-outline-gray"
                    title="Click to toggle"
            >
                <!-- up -->
                <svg xmlns="http://www.w3.org/2000/svg"
                     class="h-5 w-5"
                     :class="{'hidden': !section.shown}"
                     viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
                          clip-rule="evenodd"/>
                </svg>
                <!-- down -->
                <svg xmlns="http://www.w3.org/2000/svg"
                     class="h-5 w-5"
                     :class="{'hidden': section.shown}"
                     viewBox="0 0 20 20"
                     fill="currentColor">
                    <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                </svg>
            </button>
        </div>
        <div class="mt-6 px-4 pb-6" v-show="section.shown">
            <template v-if="sectionModel.section_type === sectionTypeWrapper" >
                <draggable :list="sectionModel.subsections"
                           item-key="uuid"
                           handle=".subsection-handle"
                           @change="saveQuote"
                >
                    <template #item="{element, index}">
                        <div class="subsection overflow-hidden border border-dashed border-gray-400 rounded-lg px-6 mb-8">
                            <div class="-mx-6 px-6 py-3 flex flex-row items-center bg-gray-100 dark:bg-gray-600 text-gray-600 dark:text-gray-300 rounded-t-lg">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3 subsection-handle cursor-move " viewBox="0 0 512 512" fill="currentColor">
                                    <path d="M512 256c0 6.797-2.891 13.28-7.938 17.84l-80 72C419.6 349.9 413.8 352 408 352c-3.312 0-6.625-.6875-9.766-2.078C389.6 346.1 384 337.5 384 328V288h-96v96l40-.0013c9.484 0 18.06 5.578 21.92 14.23s2.25 18.78-4.078 25.83l-72 80C269.3 509.1 262.8 512 255.1 512s-13.28-2.89-17.84-7.937l-71.1-80c-6.328-7.047-7.938-17.17-4.078-25.83s12.44-14.23 21.92-14.23l39.1 .0013V288H128v40c0 9.484-5.578 18.06-14.23 21.92C110.6 351.3 107.3 352 104 352c-5.812 0-11.56-2.109-16.06-6.156l-80-72C2.891 269.3 0 262.8 0 256s2.891-13.28 7.938-17.84l80-72C95 159.8 105.1 158.3 113.8 162.1C122.4 165.9 128 174.5 128 184V224h95.1V128l-39.1-.0013c-9.484 0-18.06-5.578-21.92-14.23S159.8 94.99 166.2 87.94l71.1-80c9.125-10.09 26.56-10.09 35.69 0l72 80c6.328 7.047 7.938 17.17 4.078 25.83s-12.44 14.23-21.92 14.23l-40 .0013V224H384V184c0-9.484 5.578-18.06 14.23-21.92c8.656-3.812 18.77-2.266 25.83 4.078l80 72C509.1 242.7 512 249.2 512 256z"/>
                                </svg>

                                <label class="block text-sm w-2/5">
                                    <jet-input type="text"
                                               class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-red-400 focus:outline-none focus:shadow-outline-red dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
                                               placeholder="Subsection Title"
                                               v-model="element.name"
                                               @change.prevent="saveQuote"
                                    />
                                </label>

                                <button @click.prevent="cloneSection(element, section.subsections)"
                                        class="flex items-center justify-between p-2 ml-auto font-medium leading-5 text-white transition-colors duration-150 bg-gray-600 border border-transparent rounded-lg active:bg-gray-600 hover:bg-gray-700 dark:bg-gray-500 dark:hover:bg-gray-400 focus:outline-none focus:shadow-outline-gray"
                                        title="Clone Subsection"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                        <path d="M9 2a2 2 0 00-2 2v8a2 2 0 002 2h6a2 2 0 002-2V6.414A2 2 0 0016.414 5L14 2.586A2 2 0 0012.586 2H9z" />
                                        <path d="M3 8a2 2 0 012-2v10h8a2 2 0 01-2 2H5a2 2 0 01-2-2V8z" />
                                    </svg>
                                </button>
                                <button @click.prevent="removeSection(sectionModel.subsections, index)"
                                        class="flex items-center justify-between p-2 ml-1 font-medium leading-5 text-white transition-colors duration-150 bg-gray-600 border border-transparent rounded-lg active:bg-gray-600 hover:bg-gray-700 dark:bg-gray-500 dark:hover:bg-gray-400 focus:outline-none focus:shadow-outline-gray"
                                        title="Delete Subsection"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none"
                                         viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                                    </svg>
                                </button>
                                <button @click.prevent="element.shown = ! element.shown"
                                        class="flex items-center justify-between p-2 ml-1 font-medium leading-5 text-white transition-colors duration-150 bg-gray-600 border border-transparent rounded-lg active:bg-gray-600 hover:bg-gray-700 dark:bg-gray-500 dark:hover:bg-gray-400 focus:outline-none focus:shadow-outline-gray"
                                        title="Click to toggle"
                                >
                                    <!-- up -->
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                         class="h-5 w-5"
                                         :class="{'hidden': !element.shown}"
                                         viewBox="0 0 20 20"
                                         fill="currentColor">
                                        <path fill-rule="evenodd" d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
                                              clip-rule="evenodd"/>
                                    </svg>
                                    <!-- down -->
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                         class="h-5 w-5"
                                         :class="{'hidden': element.shown}"
                                         viewBox="0 0 20 20"
                                         fill="currentColor">
                                        <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                                    </svg>
                                </button>
                            </div>

                            <!-- Content Blocks -->
                            <quote-section-content-editor :client="client"
                                                          :quote="quote"
                                                          @open-block-type-modal="openBlockTypeModal"
                                                          @open-block-preview-modal="openBlockPreviewModal"
                                                          @open-block-edit-modal="openBlockEditModal"
                                                          v-show="element.shown"
                                                          v-model:blocks-model="element.blocks"
                                                          @save-quote="saveQuote"
                                                          @blocks-changed="handleBlocksChanged(element)"
                            >
                            </quote-section-content-editor>
                        </div>
                    </template>
                </draggable>
            </template>

            <div v-else-if="sectionModel.section_type === sectionTypeContent" class="py-4 border border-dashed border-gray-400 rounded-lg px-6 mb-8">
                <!-- Content Blocks -->
                <quote-section-content-editor :client="client"
                                              :quote="quote"
                                              @open-block-type-modal="openBlockTypeModal"
                                              @open-block-preview-modal="openBlockPreviewModal"
                                              @open-block-edit-modal="openBlockEditModal"
                                              v-model:blocks-model="sectionModel.blocks"
                                              @save-quote="saveQuote"
                                              @blocks-changed="handleBlocksChanged(sectionModel)"
                >
                </quote-section-content-editor>
            </div>

            <jet-button v-if="sectionModel.section_type === sectionTypeWrapper"
                class="flex items-center justify-between px-5 py-3 font-medium leading-5 text-white transition-colors duration-150 bg-red-600 border border-transparent rounded-lg active:bg-red-600 hover:bg-red-700 focus:outline-none focus:shadow-outline-red"
                @click.prevent="addSection(sectionModel.subsections, sectionTypeContent)"
            >
                <span class="mr-2" aria-hidden="true">+</span>
                <span>Subsection</span>
            </jet-button>

        </div>
    </div>
</template>

<script>
import JetInput from '@/Jetstream/Input';
import JetButton from '@/Jetstream/Button';
import {useSections} from "@/includes/useSections";
import {useModelWrapper} from "@/includes/modelWrapper";
import QuoteSectionContentEditor from "@/Pages/Admin/Quote/Partials/QuoteSectionContentEditor";
import Draggable from "vuedraggable";


export default {
    name: "QuoteSectionEditor",
    components: {
        Draggable,
        QuoteSectionContentEditor,
        JetInput,
        JetButton
    },
    props: {
        client: {
            type: Object,
            required: false,
        },
        quote: {
            type: Object,
            required: false,
        },
        section: {
            type: Object,
            required: true,
        },
    },
    setup(props, {emit}) {

        const sectionModel = useModelWrapper(props, emit, 'section');

        const saveQuote = () => {
            emit('save-quote');
        };

        const {sectionTypeWrapper, sectionTypeContent, addSection, removeSection, cloneSection} = useSections(saveQuote);

        const removeSelf = () => emit('remove-self');

        const cloneSelf = () => emit('clone-self');

        const openBlockTypeModal = (callback) => {
            emit('open-block-type-modal', callback);
        }

        const handleBlocksChanged = (section) => {
            section.blocksChanged = true;
            saveQuote();
        }

        const openBlockPreviewModal = (element) => {
            emit('open-block-preview-modal', element);
        }
        const openBlockEditModal = (data) => {
            emit('open-block-edit-modal', data);
        }

        return {
            sectionTypeWrapper,
            sectionTypeContent,
            sectionModel,
            addSection,
            removeSection,
            removeSelf,
            cloneSelf,
            cloneSection,
            openBlockTypeModal,
            openBlockPreviewModal,
            saveQuote,
            handleBlocksChanged,
            openBlockEditModal,
        }
    }
}
</script>

<style scoped>

</style>
